export enum PaymentItemInitialEnteredAmount {
	accountBalance,
	pendingBalance
}
